// import styles from "./Home.module.sass";
import Carousel from "./Carousel";
import Team from "./Team";
import Journey from "./Journey";
import Roadmap from "./Roadmap";
import Trust from "./Trust";
import Experts from "./Experts";

const Home = () => {
  return (
    <>
      <Carousel />
      <Journey />
      <Roadmap />
      <Trust />
      <Experts />
      <Team />
    </>
  );
};

export default Home;
